import Stack from "@mui/material/Stack";
import Button from "@mui/material/Button";
import { useState } from "react";
import { toast } from "react-toastify";
import TextField from "@mui/material/TextField";

import EstimatorForm from "../../components/EstimatorForm";
import { TopControl } from "../../components/top-control/top-control";
import {
  encodedPasswordState,
  rfidPasswordState,
  generatePassword,
  inksState,
  inkTankState,
  loadingState,
  machineSerialNumberState,
  newMachine,
  generateRfidPassword,
  sernumsState
} from "../../state/sernums/sernums.slice";
import { useEstimatorFormStyles } from "../../components/EstimatorForm/EstimatorForm.styles";

import { useAppDispatch, useAppSelector } from "../../state/store";

import { TokenModal } from "../../components/Modal/modal/token-modal";

const PassGen = (): JSX.Element => {
  const dispatch = useAppDispatch();
  const sx = useEstimatorFormStyles();

  const sernumsData = useAppSelector(sernumsState);
  const encodedPassword = useAppSelector(encodedPasswordState);
  const rfidPassword = useAppSelector(rfidPasswordState);
  const loading = useAppSelector(loadingState);
  const inkTank = useAppSelector(inkTankState);
  const inks = useAppSelector(inksState);
  const machineSerialNumber = useAppSelector(machineSerialNumberState);

  const [modal, setModal] = useState(false);
  const [rfidmodal, setRfidModal] = useState(false);
  const [polymerName, setPolymerName] = useState('');
  const [version, setVersion] = useState("");

  const isRfidAllowed = sessionStorage.getItem("isRfidAllowed") === "true";

  const generatePasswordJson = async () => {
    if (version === "Version8" && (!inks.some((ink) => ink.value) || !inkTank.value)) {
      toast.error("Version8 requires selecting polymer types and an ink tank.");
      return;
    }

    const otherTanks = inks.map((ink) => `${ink.value}`);

    const convertedSernums = Object.entries(sernumsData).reduce<{ [key: string]: boolean | string }>((acc, [key, value]) => {
      acc[key] = value === "Y" ? true : value;
      return acc;
    }, {});

    console.log('inkTank.value', inkTank.value);

    // Default machineId is null; it may be set by the BI \"new machine\" call below
    let machineId: number | null = null;

    if (convertedSernums.INHOUSEPRESS === false || convertedSernums.INHOUSEPRESS === null) {
      console.log('in house flag:', convertedSernums.INHOUSEPRESS);
      const machineName = convertedSernums.CDES + ' ' + machineSerialNumber;
      const biData = { machine_name: machineName, machine_serial_number: machineSerialNumber, machine_type: convertedSernums.PRESSTYPEDES };
      const biDataJsonPretty = JSON.stringify(biData, null, 2);
      console.log(biDataJsonPretty);
      try {
        const response = await dispatch(newMachine(biDataJsonPretty)).unwrap();
        machineId = response?.machine_id; // assuming the API returns machine_id in its response
      } catch (err) {
        console.error("Error initializing new machine:", err);
      }
    }

    // Build extendedData after (optional) newMachine call; always include machine_id (possibly null)
    const tanksPayload = inkTank.value
      ? {
        active: inkTank.value,
        Tank1: otherTanks[0],
        Tank2: otherTanks[1],
        Tank3: otherTanks[2],
        Tank4: otherTanks[3],
        Tank5: otherTanks[4]
      }
      : [];

    const extendedData = {
      ...{ ...convertedSernums, MACHINESERIALNUM: machineSerialNumber, machine_id: machineId },
      tanks: tanksPayload
    };

    const extendedDataJsonPretty = JSON.stringify(extendedData, null, 2);
    dispatch(generatePassword(extendedDataJsonPretty))
      .unwrap()
      .then(() => {
        setModal(true);
      });
  };
  const generateRfidPasswordJson = (polymerName: string) => {
    const polymerData = {
      polymer_type: polymerName
    };
    console.log(polymerData)
    const polymerDataJsonPretty = JSON.stringify(polymerData, null, 2);
    // console.log("Polymer Data JSON:", polymerDataJsonPretty);
    dispatch(generateRfidPassword(polymerDataJsonPretty))
      .unwrap()
      .then((response) => {
        console.log("Full response:", response);

        const token = response.Token; // Use capital 'T' as returned by the API
        if (!token) {
          console.error("Token is missing from response");
          return;
        }
        console.log("RFID Password Token:", token);
        setRfidModal(true);
        
      });
  };


  const handleCopy = async (token: string) => {
    try {
      await navigator.clipboard.writeText(token);
      alert("Token copied to clipboard!");
    } catch (error) {
      alert("Failed to copy the token.");
    }
  };
  return ( 
    <Stack sx={sx.mainWrapper}>
      <Stack gap={2} sx={{ width: "100%" }}>
        <TopControl version={version} onVersionChange={setVersion} />
        <EstimatorForm showAdvance={!!version} required={version === "Version8"} />
        <Stack spacing={2}>
          <Stack direction="row" justifyContent="center">
            <Button variant="contained" onClick={generatePasswordJson} disabled={!version} sx={{ width: '25%' }}>
              Generate password
            </Button>
          </Stack>
          {isRfidAllowed && (
            <Stack direction="row" alignItems="center" justifyContent="center" spacing={2} sx={{ paddingBottom: '30px' }}>
              <Button variant="contained" onClick={() => generateRfidPasswordJson(polymerName)} sx={{ width: '20%' }}>
                RFID password
              </Button>
              <TextField
                placeholder="Insert Polymer Name : PS800"
                value={polymerName}
                onChange={(e) => setPolymerName(e.target.value)}
                inputProps={{ inputMode: "numeric", pattern: "[0-9]*", maxLength: 6 }}
                sx={{ width: '20%', paddingLeft: '10px', paddingRight: '10px' }}
              />
            </Stack>
          )}
        </Stack>
        </Stack>

      {encodedPassword && modal && <TokenModal open={modal} onClose={() => { setModal(false);  }} token={encodedPassword} onCopy={handleCopy}  title='Scodix Machine Password'/>}
      {rfidPassword && rfidmodal && <TokenModal open={rfidmodal} onClose={() => { setRfidModal(false); }} token={rfidPassword} onCopy={handleCopy} title='Scodix RFID Password' />}
      
    </Stack>
  );
};

export default PassGen;
